module.exports = __webpack_public_path__ + "static/media/tr.d1252e53.svg";